<template>
<div class="p-plan-permission-blocker g-page">
  <div class="p-plan-permission-blocker__container">
    <LockIcon
      height="200"
      width="200"
      class="p-plan-permission-blocker__icon"
      color="#DEE2E6"
    />
    <i18n class="p-plan-permission-blocker__text-colour"
          :path="blockedFeature"
          tag="span">
      <b>{{ planSize }}</b>
    </i18n>
    <VButton
      type="cta-1"
      class="p-plan-permission-blocker__button"
      to="/company-settings/billing"
      data-test="button-new-team"
      :data-ec="`plan_permission_blocker_${ec}`"
      data-et="manage_plan_button">
      <ArrowCircleUpIcon />
      <span>{{ $t('teams.managePlan') }}</span>
    </VButton>
  </div>
</div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import { ArrowCircleUpIcon, LockIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VPlanPermissionBlocker',
  props: {
    ec: String,
    planSize: {
      type: String,
      required: true,
    },
    blockedFeature: {
      type: String,
      required: true,
    },
  },
  components: {
    VButton,
    ArrowCircleUpIcon,
    LockIcon,
  },
};
</script>

<style scoped>
.p-plan-permission-blocker__container {
  height: auto;
  width: 100%;
  border: 2px dashed #DEE2E6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.p-plan-permission-blocker__icon {
  margin: 100px 0 var(--spacing-large) 0;
}

.p-plan-permission-blocker__button {
  margin: var(--spacing-small) 0 100px 0;
  height: 40px;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-plan-permission-blocker__text-colour {
  color: #e67e22;
}
</style>
